module.exports = __webpack_public_path__ + "img/img-1.645e1fe8.png";